import WorldMap from './WorldMap'

export default WorldMap
